<template>
<span>
    {{title}}
    <i class="sort">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path class="down" fill-rule="evenodd" clip-rule="evenodd"
                  d="M9.35355 7.64645C9.54882 7.84171 9.54882 8.15829 9.35355 8.35355L6.35355 11.3536C6.15829 11.5488 5.84171 11.5488 5.64645 11.3536L2.64645 8.35355C2.45118 8.15829 2.45118 7.84171 2.64645 7.64645C2.84171 7.45118 3.15829 7.45118 3.35355 7.64645L6 10.2929L8.64645 7.64645C8.84171 7.45118 9.15829 7.45118 9.35355 7.64645Z"
                  fill="#C2CAD8"/>
            <path class="top" fill-rule="evenodd" clip-rule="evenodd"
                  d="M9.35355 4.35355C9.15829 4.54882 8.84171 4.54882 8.64645 4.35355L6 1.70711L3.35355 4.35355C3.15829 4.54882 2.84171 4.54882 2.64645 4.35355C2.45118 4.15829 2.45118 3.84171 2.64645 3.64645L5.64645 0.646446C5.84171 0.451184 6.15829 0.451184 6.35355 0.646446L9.35355 3.64645C9.54882 3.84171 9.54882 4.15829 9.35355 4.35355Z"
                  fill="#C2CAD8"/>
        </svg>
    </i>
</span>
</template>

<script>
    module.exports = {
        props: {
            title: {
                type: String
            },
            column: {
                type: String
            }
        },
        // watch: {
        //     title: function() {
        //         this.titleLocal = this.title;
        //     }
        // },
        data: function() {
            return {
                titleLocal: ""
            };
        },
        methods: {}
    };
</script>
